import type { ActivityType } from '@nx/domain';

export function activityTypeKind(type: ActivityType | string): string {
  const map: Record<string, string> = {
    talk: 'olive',
    workshop: 'olive',
    roundtable: 'olive',
    break: 'clay',
    meal: 'clay',
    other: 'muted',
  };
  return map[type] ?? 'muted';
}

export function activityTypeLabel(type: ActivityType | string): string {
  const labels: Record<string, string> = {
    talk: 'Talk',
    workshop: 'Workshop',
    roundtable: 'Roundtable',
    break: 'Break',
    meal: 'F&B',
    other: 'Other',
  };
  return labels[type] ?? String(type);
}
